import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    pageSelectList: {
      transform: 'translate(0px,40px)',
      '& .MuiMenuItem-root': {
        color: '#2C2D3E',
        padding: '0px 0px 0px 15px',
        fontSize: '13px',
        '&:focus': {
          color: '#2C2D3E',
        },
        '&:hover': {
          backgroundColor: '#CACAFC',
        },
      },
      '& .MuiMenu-list': {
        width: '122px',
        // height: '80px',
        // height: '110px',
      },
    },
    cardPreviewMenuIcon: {
      width: '22px',
      height: '22px',
      margin: '3px 10px',
      cursor: 'pointer',
    },
    pageSelectMenuIcon: {
      width: '18px',
      height: '18px',
      margin: '10px 0px',
      marginRight: '19px',
      cursor: 'pointer',
    },
    pageSelectMenuIcon2: {
      width: '25px',
      height: '13px',
      margin: '10px 0px',
      marginRight: '14px',
      cursor: 'pointer',
    },
    pageSelectMenuIcon4: {
      width: '22px',
      height: '22px',
      margin: '10px 0px',
      marginRight: '15px',
      cursor: 'pointer',
    },
    disabledAction: {
      position:'absolute',
      top: '8px', 
      left: '12px', 
      height:'25%',
      width:'25%',
      color:'black'
    },
  }),
);
